// @flow
import { ExperiencesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    experience: {},
    listaExperiences: [],
    loading: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type ExperiencesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string, params?: any },
};
type State = { experience?: {} | null, listaExperiences?: [] | null, loading?: boolean, +value ?: boolean };

const Experiences = (state: State = INIT_STATE, action: ExperiencesAction): any => {
    // console.log(action);
    switch (action.type) {
        case ExperiencesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ExperiencesActionTypes.GET_EXPERIENCE: {
                    return {
                        ...state,
                        experience: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ExperiencesActionTypes.LIST_EXPERIENCES: {
                    return {
                        ...state,
                        listaExperiences: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ExperiencesActionTypes.ADD_EXPERIENCE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ExperiencesActionTypes.UPDATE_EXPERIENCE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ExperiencesActionTypes.DELETE_EXPERIENCE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ExperiencesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ExperiencesActionTypes.GET_EXPERIENCE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        experience: {},
                        loading: false,
                    };
                }
                case ExperiencesActionTypes.LIST_EXPERIENCES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaExperiences: [],
                        loading: false,
                    };
                }
                case ExperiencesActionTypes.ADD_EXPERIENCE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ExperiencesActionTypes.UPDATE_EXPERIENCE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ExperiencesActionTypes.DELETE_EXPERIENCE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ExperiencesActionTypes.GET_EXPERIENCE:
            return { ...state, error: false, loading: true };
        case ExperiencesActionTypes.LIST_EXPERIENCES:
            return { ...state, error: false, loading: true };
        case ExperiencesActionTypes.ADD_EXPERIENCE:
            return { ...state, error: false, loading: true };
        case ExperiencesActionTypes.UPDATE_EXPERIENCE:
            return { ...state, error: false, loading: true };
        case ExperiencesActionTypes.DELETE_EXPERIENCE:
            return { ...state, error: false, loading: true };
        case ExperiencesActionTypes.RESET:
            return {
                ...state,
                experience: {},
                listaExperiences: [],
                loading: false,
                error: false,
                formSubmited: false
            };
        case ExperiencesActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default Experiences;
